import React from 'react';
import { ApplicationView } from '@aha-app/mvc';
import { useReadOnly } from 'slate-react';
import type { ComponentProps, LinkElement } from '../../../types/aha-editor';
import { useLinkHandlers, getLinkAttributes } from '../utils';
import useAhaEditorFocused from '../../../components/useAhaEditorFocused';

const LinkComponent: React.FC<ComponentProps<LinkElement>> = ({
  attributes,
  transformedElement: element,
  children,
}) => {
  const href = element.link_href || '#';
  const linkTarget = element.link_target;
  const focused = useAhaEditorFocused();
  const readOnly = useReadOnly();

  const { handleMouseDown, handleClick } = useLinkHandlers({
    href,
    linkTarget,
    focused,
    readOnly,
  });

  const extraAttrs = getLinkAttributes(href, linkTarget);

  return (
    <a
      href={element.link_href}
      {...attributes}
      {...extraAttrs}
      onMouseDown={handleMouseDown}
      onClick={handleClick}
    >
      {children}
    </a>
  );
};

export default ApplicationView(LinkComponent);
